import { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import BannerSlider from '../../components/BannerSlider';
import BaseLayout from '../../components/BaseLayout';
import Feeds from '../../components/Feeds';
import Menu from '../../components/Menu';
import PointInfo from '../../components/PointInfo';
import CarouselSlider from '../../components/CarouselSlider';
import Section from '../../components/Section';
import IndexPointSummary from './indexPointSummary';
import useCheckConnection from '../../hooks/useCheckConnection';
import * as PageRoutes from './../../utils/route_pages';
import * as Assets from '../../utils/svg_assets';
import ApiUtils from '../../utils/api_utils';
import DynamicManifest from '../../components/DynamicManifest/indext';

const HomePage = (props) => {
  const { pwa_setting: pwaSetting, initFeeds } = props;
  const navigate = useNavigate();
  const latestNews = useSelector(
    (state) => state.FeedsSM.feedDataDashboard.latest
  );
  const highlightList = useSelector(
    (state) => state.FeedsSM.feedDataDashboard.featured
  );

  const organization = useSelector(
    (state) => state.LoginSM.login.organization_structure_label
  );
  const {
    organization_icon: icon,
    name,
    use_icon: isUseIcon,
  } = organization[0].organization;

  const { isOnline } = useCheckConnection();
  const [isShowOther, setIsShowOther] = useState(false);

  const [isShow, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const isIos = () => {
    return (
      ['iPhone', 'iPad', 'iPod'].includes(navigator.platform) ||
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    );
  };

  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const handleAdd = async () => {
    <DynamicManifest appName={name} shortName={name} />;

    deferredPrompt.prompt();
    const choiceResult = await deferredPrompt.userChoice;
    if (choiceResult.outcome === 'accepted') {
      console.log('User accepted the install prompt');
    } else {
      console.log('User dismissed the install prompt');
    }
    setDeferredPrompt(null);
    setShow(false);

    // if (isIos()) {
    //   // Show a custom message or modal for iOS users
    //   alert(
    //     'To add this app to your home screen, tap the Share button and then "Add to Home Screen".'
    //   );
    //   setShow(false);
    // } else if (deferredPrompt) {
    //   // Handle Android/Chrome-based PWA installation
    //   deferredPrompt.prompt();
    //   const choiceResult = await deferredPrompt.userChoice;
    //   if (choiceResult.outcome === 'accepted') {
    //     console.log('User accepted the install prompt');
    //   } else {
    //     console.log('User dismissed the install prompt');
    //   }
    //   setDeferredPrompt(null);
    //   setShow(false);
    // } else {
    //   alert('The install prompt is not available.');
    //   setShow(false);
    // }
  };

  useEffect(() => {
    initFeeds();
  }, []);

  useEffect(() => {
    // Listen for the beforeinstallprompt event
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault(); // Prevent automatic prompt
      setDeferredPrompt(e); // Store the event for later use
    });
  }, []);

  const RenderNoInternetConnection = () => {
    return (
      <div className="d-flex align-items-center justify-content-around wrapper-no-connection">
        <div>
          <div className="font-bold">No Connection Found</div>
          <div>Please check your network connection</div>
        </div>
        <div>
          <img src={Assets.iconWifiOff} alt="wifi off" />
        </div>
      </div>
    );
  };

  const onHandleOther = () => {
    setIsShowOther(!isShowOther);
  };

  return (
    <div>
      {pwaSetting.redirect === 2 ? (
        <IndexPointSummary />
      ) : (
        <div className="home-page">
          <BaseLayout
            bottomNavIndex={0}
            show_menu={!isShowOther ? true : false}
            header={
              <BannerSlider
                data={highlightList}
                isLogo={true}
                isBottom={true}
                isRight={true}
                isHighlight={true}
              />
            }
            isCustom={true}
          >
            <div>
              {!isShowOther ? (
                <PointInfo />
              ) : (
                <div
                  className="mt-4"
                  // onClick={() => onHandleOther()}
                ></div>
              )}
              <Menu
                onHandleOther={() => onHandleOther()}
                isShowOther={isShowOther}
              />
              <Modal show={isShow} onHide={handleClose} centered>
                <Modal.Body className="p-4">
                  <h5 className="fw-bold fs-13 text-start">
                    Add to Home screen?
                  </h5>
                  <p className="text-muted mb-4 fs-12 text-start">
                    Touch and hold an icon or tap Add to add it to the Home
                    screen.
                  </p>
                  <div className="icon-container d-flex flex-column align-items-center body-shortcut-wrapper">
                    <div className="icon-wrapper-shortcut mt-4">
                      <div id="menus">
                        <div className="menu-list">
                          <div className="icon-wrapper-shortcut">
                            <i>
                              <img
                                src={Assets.logo}
                                alt="logo"
                                className="logo-org"
                                width="24px"
                              />
                              {/* {!isUseIcon ? (
                                <img
                                  src={Assets.logo}
                                  alt="logo"
                                  className="logo-org"
                                  width="24px"
                                />
                              ) : (
                                <img
                                  src={ApiUtils.validateImgUrl({ url: icon })}
                                  alt="logo"
                                  className="logo-org"
                                  width="24px"
                                />
                              )} */}
                            </i>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <p className="mt-3 fs-12">{name}</p> */}
                    <p className="mt-3 fs-12">Skorpoints</p>
                  </div>
                </Modal.Body>
                <Modal.Footer className="popup-buttons">
                  <Button
                    className="custom-button mh-30px fs-14"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="custom-button mh-30px fs-14"
                    onClick={handleAdd}
                  >
                    Add
                  </Button>
                </Modal.Footer>
              </Modal>
              {!isShowOther ? (
                <>
                  <div className="d-flex align-items-center justify-content-between mb-3 p-2">
                    <div className="d-flex align-items-center">
                      <div className="icon-wrapper-shortcut me-3">
                        <div id="menus">
                          <div className="menu-list">
                            <div className="icon-wrapper-shortcut">
                              <i>
                                <img
                                  src={Assets.logo}
                                  alt="logo"
                                  className="logo-org"
                                  width="24px"
                                />
                                {/* {!isUseIcon ? (
                                  <img
                                    src={Assets.logo}
                                    alt="logo"
                                    className="logo-org"
                                    width="24px"
                                  />
                                ) : (
                                  <img
                                    src={ApiUtils.validateImgUrl({ url: icon })}
                                    alt="logo"
                                    className="logo-org"
                                    width="24px"
                                  />
                                )} */}
                              </i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <label className="fs-14 fw-bold m-0">
                        Would you like to add <br />a shortcut to your home
                        screen?
                      </label>
                    </div>
                    <button
                      className="btn btn-outline-danger d-flex align-items-center no-focus"
                      style={{
                        width: '76px',
                        fontSize: '12px',
                        height: '30px',
                        fontWeight: 'bold',
                        borderRadius: '4px',
                        outline: 'none',
                        boxShadow: 'none',
                        backgroundColor: 'transparent',
                      }}
                      onClick={handleShow}
                    >
                      <label className="fs-14 m-0">ADD</label>
                      <img
                        src={Assets.iconPlus}
                        alt="plus-icon"
                        className="ms-2"
                        style={{ width: '12px' }}
                      />
                    </button>
                  </div>
                  <div className={isOnline ? 'd-block' : 'd-none'}>
                    <Section
                      title="Latest News"
                      seeText="See all news"
                      className={'mb-3'}
                      onClick={() => navigate(PageRoutes.news)}
                    />
                    <CarouselSlider data={latestNews} />
                    <Feeds />
                  </div>
                  <div className={isOnline ? 'd-none' : 'd-block'}>
                    <RenderNoInternetConnection />
                  </div>
                  <br />
                  <br />
                  <br />
                  <br />
                </>
              ) : null}
            </div>
          </BaseLayout>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  pwa_setting: state.LoginSM.login.organization_pwa_settings,
});

const mapDispatchToProps = (dispatch) => ({
  initFeeds: dispatch.FeedsSM.initFeeds,
});

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
